import Core from 'src/Core'
import Queue from 'src/Queue'
import Logger from 'src/initializers/Logger'
import { PublicError } from 'src/Error'
import { NOT_INITIALIZED, OTHER } from 'src/ErrorCodes'

const NAME = Core.get('NAME')

export default class QueueSerial extends Queue {
  _execute () {
    const functionToCall = arguments[0]
    const argumentsToPass = Array.prototype.slice.call(arguments, 1)

    if (!this._promiseStack) {
      this._promiseStack = Promise.resolve()
    }

    // new API : PE(() => { console.log('loaded') })
    if (typeof functionToCall === 'function') {
      this._promiseLoaded.then(functionToCall)
      return this._promiseStack
    }

    // old API : PE('loaded', () => { console.log('loaded') })
    if (functionToCall === 'loaded') {
      Logger.warn(`(DeprecationWarning) using "${NAME}('loaded',function() {})" is deprecated - use "${NAME}(function() {})" instead`)
      this._promiseLoaded.then(argumentsToPass[0])
      return this._promiseStack
    }

    Logger.warn(`(DeprecationWarning) using "${NAME}('${functionToCall}', ...)" is deprecated - use "${NAME}.client.${functionToCall}(...)" instead (encapsulated in "${NAME}(function() {})")`)

    /*
    if ((functionToCall === 'uploadWithFileInput') && (Core.get('PARTNER_NAME') === 'Bioderma')) {
      if (Core.get('UPLOAD_LOCK')) {
        // only one upload at a time
        return this._promiseStack
      }
      Core.set('UPLOAD_LOCK', true)
    }
    */

    const newPromiseStack = this._promiseStack.then(
      () => {
        if (this.api[functionToCall] && typeof this.api[functionToCall] === 'function') {
          if (functionToCall !== 'init' && !this.api.isInitialized()) {
            return Promise.reject(new PublicError(NOT_INITIALIZED, 'SDK not initialized'))
          }
          return this.api[functionToCall].apply(this.api, argumentsToPass)
        }
        return Promise.reject(new PublicError(OTHER, 'undefined method ' + functionToCall))
      }
    )

    // ensure that we never block the stack
    this._promiseStack = newPromiseStack.catch(Core.promiseInQueueHandleError)

    return newPromiseStack
  }
}



// WEBPACK FOOTER //
// ./src/QueueSerial.js